import script from "./SettlementRateCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SettlementRateCard.vue?vue&type=script&setup=true&lang=js"

import "./SettlementRateCard.vue?vue&type=style&index=0&id=0a05711e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a05711e"]])

export default __exports__